// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cl-bc-legend-item[data-v-0f9f4c6a] {
    color: #666;
    font-size: 12px;
    line-height: 20px;
}
.cl-bc-legend-bullet[data-v-0f9f4c6a] {
    width: 10px;
    height: 10px;
    margin-right: 5px;
    display: inline-block;
}
.colored-circle-blue[data-v-0f9f4c6a] {
    background-color: #009adf;
    border-radius: 5px;
}
.colored-circle-gray[data-v-0f9f4c6a] {
    background-color: #ccc;
    border-radius: 5px;
}
.colored-square-blue[data-v-0f9f4c6a] {
    background-color: #009adf;
}
.colored-square-navy[data-v-0f9f4c6a] {
    background-color: #199BDD;
}
.colored-square-gray[data-v-0f9f4c6a] {
    background-color: #666;
}
@media (max-width: 768px) {
.cl-bc-legend-item[data-v-0f9f4c6a] {
        display: block;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/growth-10k/HorizontalLegend.vue"],"names":[],"mappings":";AA0BA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,yBAAyB;AAC7B;AAEA;IACI,sBAAsB;AAC1B;AAEA;AACI;QACI,cAAc;AAClB;AACJ","sourcesContent":["<template>\n    <ul class=\"list-inline\">\n        <li v-for=\"(item, index) in data\" :key=\"index\" class=\"cl-bc-legend-item\">\n            <div :class=\"`cl-bc-legend-bullet colored-${item.shape}-${item.color}`\" />\n            {{ item.text }}\n            <!-- @slot iball descriptor if item have a slot key -->\n            <slot v-if=\"item.slot\" :name=\"item.slot\" />\n            <slot v-if=\"item.IBallSlot\" :name=\"item.IBallSlot\" />\n            <slot v-if=\"item.superscriptSlot\" :name=\"item.superscriptSlot\" />\n        </li>\n    </ul>\n</template>\n\n<script>\nexport default {\n\tname: 'HorizontalLegend',\n\tprops: {\n\t\tdata: {\n\t\t\ttype: Array,\n\t\t\tdefault: () => []\n\t\t}\n\t}\n};\n</script>\n\n<style scoped>\n.cl-bc-legend-item {\n    color: #666;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.cl-bc-legend-bullet {\n    width: 10px;\n    height: 10px;\n    margin-right: 5px;\n    display: inline-block;\n}\n\n.colored-circle-blue {\n    background-color: #009adf;\n    border-radius: 5px;\n}\n\n.colored-circle-gray {\n    background-color: #ccc;\n    border-radius: 5px;\n}\n\n.colored-square-blue {\n    background-color: #009adf;\n}\n\n.colored-square-navy {\n    background-color: #199BDD;\n}\n\n.colored-square-gray {\n    background-color: #666;\n}\n\n@media (max-width: 768px) {\n    .cl-bc-legend-item {\n        display: block;\n    }\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
